import { render, staticRenderFns } from "./WildCardSection.vue?vue&type=template&id=19233495&"
import script from "./WildCardSection.vue?vue&type=script&lang=js&"
export * from "./WildCardSection.vue?vue&type=script&lang=js&"
import style0 from "./WildCardSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports